export const ACTIVE_ORDER_STATUSES = [
  'pending_payment',
  'pending_vendor_approval',
  'confirmed',
  'preparing',
  'ready',
];

export const PAST_ORDER_STATUSES = ['picked_up', 'cancelled'];

const READINESS = {
  ready: {
    label: 'Ready for pickup',
    detail: 'Your order is waiting at the truck',
    badgeClass: 'bg-green-100 text-green-800',
  },
  pending_payment: {
    label: 'Payment incomplete',
    detail: 'Finish payment to send this order to the vendor',
    badgeClass: 'bg-yellow-100 text-yellow-800',
  },
  pending_vendor_approval: {
    label: 'Not ready yet',
    detail: 'Waiting for the vendor to accept your order',
    badgeClass: 'bg-yellow-100 text-yellow-800',
  },
  confirmed: {
    label: 'Not ready yet',
    detail: 'The vendor accepted your order',
    badgeClass: 'bg-blue-100 text-blue-800',
  },
  preparing: {
    label: 'Not ready yet',
    detail: 'Your order is being prepared',
    badgeClass: 'bg-orange-100 text-orange-800',
  },
  picked_up: {
    label: 'Picked up',
    detail: 'This order has been collected',
    badgeClass: 'bg-gray-100 text-gray-800',
  },
  cancelled: {
    label: 'Cancelled',
    detail: 'This order was cancelled',
    badgeClass: 'bg-red-100 text-red-800',
  },
};

export function getOrderReadiness(orderOrStatus) {
  const status = typeof orderOrStatus === 'string' ? orderOrStatus : orderOrStatus?.status;
  return READINESS[status] || {
    label: 'Not ready yet',
    detail: 'Order status is being updated',
    badgeClass: 'bg-gray-100 text-gray-800',
  };
}

export function isActiveOrder(order) {
  return ACTIVE_ORDER_STATUSES.includes(order?.status);
}

export function sortOrdersByClosestPickup(orders, now = new Date()) {
  const nowTime = new Date(now).getTime();
  const pickupTime = (order) =>
    new Date(order?.scheduled_pickup_time || order?.created_at || 0).getTime();

  return [...(orders || [])].sort((a, b) => {
    const aTime = pickupTime(a);
    const bTime = pickupTime(b);
    const aDistance = Math.abs(aTime - nowTime);
    const bDistance = Math.abs(bTime - nowTime);
    if (aDistance !== bDistance) return aDistance - bDistance;

    // At equal distance, show the upcoming pickup before one that has passed.
    const aUpcoming = aTime >= nowTime ? 0 : 1;
    const bUpcoming = bTime >= nowTime ? 0 : 1;
    if (aUpcoming !== bUpcoming) return aUpcoming - bUpcoming;
    return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
  });
}

export function formatOrderPickup(isoString) {
  if (!isoString) return 'Pickup time not set';
  return new Date(isoString).toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'America/Toronto',
  });
}

export function orderItemsSummary(order) {
  const items = Array.isArray(order?.items) ? order.items : [];
  if (!items.length) return 'No items';
  return items
    .map((item) => `${item.quantity || 1} × ${item.name || 'Item'}`)
    .join(', ');
}
